import React, { useEffect, useState } from "react";
// import alertIcon from "../../../images/alert.png";
import useStyles from "../../../components/common/model/styles";
import Popup from "../../../components/common/model/Popup";
import { Alert, DialogContent, DialogContentText } from "@mui/material";
import closeIcon from "../../../assets/closeModel.png";
import CustomButton from "../../../components/common/button/CustomButton";
import { useDispatch } from "react-redux";
import {
  getResetPasswordAction,
  getSingleTelnetAction,
  getTelnetActivityAction,
  setResetPasswordAction,
  setResetPasswordSuccessAction,
} from "../../../store/reducers/adminClientsSlice";
import { useSelector } from "react-redux";
import Notification from "../../../components/common/notification/Notification";
import { setNotificationAction } from "../../../store/reducers/mmymSlice";
interface ResetPasswordPopupProps {
  resetPasswordRec?: string;
  onHide?: () => void;
  resetPasswordModalShow: boolean;
  clientDetails?: any;
  setResetPasswordModalShow: (show: boolean) => void;
  setShowSuccessMessage?: (message: string) => void;
  setIsUpdated?: any;
  isUpdated?: any;
  setTenantId?:any;
}

const ResetPasswordPopup: React.FC<ResetPasswordPopupProps> = ({
  onHide,
  resetPasswordModalShow,
  setResetPasswordModalShow,

  clientDetails,
  setIsUpdated,
  isUpdated,setTenantId
}) => {

  const dispatch = useDispatch();
  const classes = useStyles();


  const { isClientResetPasswordError, isClientResetPasswordSuccess } = useSelector(
    (state: any) => state?.adminClients
  );

  console.log("clientDetails", clientDetails);
  const submitHandler = () => {
    const payload = { tenantId: clientDetails?.client_id };
    dispatch(getResetPasswordAction({ ...payload }));
  };

  useEffect(()=>{
if(isClientResetPasswordSuccess===true){
  setResetPasswordModalShow(false);
  dispatch(setResetPasswordSuccessAction(false));
  dispatch(getSingleTelnetAction(clientDetails?.client_id));
  dispatch(getTelnetActivityAction(clientDetails?.client_id));
}
  },[isClientResetPasswordSuccess])


  const closeModel = () => {
    console.log("close-model");
    dispatch(setNotificationAction({ message: [], severity: "error" }));
    setResetPasswordModalShow(false);
    dispatch(setResetPasswordAction(null));
  };

  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState<
    "sm" | "xs" | "md" | "lg" | "xl" | false
  >("xs"); // Adjust the type definition
  return (
    <Popup
      open={resetPasswordModalShow}
      title={"Reset Password"}
      onHide={closeModel}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      aria-describedby="alert-dialog-slide-description"
      header={
        <>
          <img
            onClick={onHide}
            src={closeIcon}
            className={classes.closeicons}
            alt="close"
          />
        </>
      }
      footer={
        <>
          {isClientResetPasswordError ? (
            <CustomButton
              variant="outlined"
              title="Close"
              onClick={closeModel}
            />
          ) : (
            <>
              <CustomButton variant="outlined" title="No" onClick={onHide} />
              <CustomButton title="Yes" onClick={submitHandler} />
            </>
          )}
        </>
      }
    >
      <DialogContent sx={{ padding: "0px" }}>
        <DialogContentText>
          <>
            {/* <img src={alertIcon} alt="icons" /> */}
            {isClientResetPasswordError ? (
              <Notification />
            ) : (
              <Alert
                sx={{ bgcolor: "#eeecef", fontSize: "16px" }}
                severity="warning"
              >
                Are you sure, you want to resend password link to this client?
              </Alert>
            )}
          </>
        </DialogContentText>
      </DialogContent>
    </Popup>
  );
};

export default ResetPasswordPopup;
